<blockquote class="blockquote text-center log-title mt-2">
    {{ 'Log' | translate }}
</blockquote>
<ul class="list-group">
    @for (requestLog of requestLogs; track requestLog) {
        <li class="list-group-item log-item">
            <span class="log-item__timestamp">
                {{ requestLog.time | date: 'dd.MM.yyyy HH:mm' }}
            </span>
            <span class="log-item__description">
                <app-highlight-entity [entity]="requestLog"></app-highlight-entity>
            </span>
        </li>
    }
</ul>
@if (requestLogs && requestLogs.length && requestLogs.length >= count) {
    <button type="button" class="btn btn-link d-block mx-auto" (click)="getRequestLog(requestId, skip, take)">
        {{ 'Load more' | translate }}
    </button>
}
